<div class="upload-frame mat-elevation-z8">
  <app-header
    [componentName]="compName"
    (iconClick)="searchIconClick($event)"
    (searchClick)="search($event)"
    (filterClick)="loadFilterData($event)"
  ></app-header>
  <div class="spinner-Overlay" *ngIf="displaySpinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div *ngIf="caseCount == 0">
    <p class="no-upload">{{ "CaseHistory.NoData" | translate }}</p>
  </div>
  <div
    [ngStyle]="
      totalRec > 0 ? { visibility: 'visible' } : { visibility: 'hidden' }
    "
  >
  <cdk-virtual-scroll-viewport itemSize="50" class="table-container" [ngClass]="{'expandedTable': expandTable}"> 
    <table      
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortDisableClear
      matSortActive="updateDateTime"
      matSortDirection="desc"
      (matSortChange)="sortTable($event)"
      aria-describedby="caseHistory"
      class="mrg-t"
    >
      <ng-container matColumnDef="icons">
        <th mat-header-cell id="icon" *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let element">
          <div class="infoIcons">
            <img
              id="patientDetails"
              src="assets\images\auditlog.svg"
              alt="{{ 'CaseHistory.auditlog' | translate }}"
              title="{{ 'CaseHistory.auditlog' | translate }}"
              (click)="exportLog(element.caseId)"
            />
            <img
            *ngIf="element.caseStatus == statusApproved"
              id="CaseHistory.patientDescription"
              alt="{{ 'CaseHistory.infoIcon' | translate }}"
              title="{{ 'CaseHistory.infoIcon' | translate }}"
              src="assets\images\informattion.svg"
              (click)="viewCaseDetails(element)"
            />
            <img
              *ngIf="element.caseStatus === statusRejected || (element.caseStatus == statusError)"
              id="CaseHistory.patientDescription"
              src="assets\images\bx_error-alt.svg"
              alt=" {{ 'CaseHistory.error' | translate }}"
              title=" {{ 'CaseHistory.error' | translate }}"
              (click)="viewCaseDetails(element)"
            />
          </div>
        </td>
      </ng-container>
      <!-- Case ID -->
      <ng-container matColumnDef="caseId">
        <th mat-header-cell id="caseId" *matHeaderCellDef>
          {{ "CaseHistory.caseID" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.caseId }}</td>
      </ng-container>

      <ng-container matColumnDef="anatomy">
        <th mat-header-cell id="anatomy" *matHeaderCellDef>
          {{ "CaseHistory.anatomy" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.anatomy | titlecase }}</td>
      </ng-container>
      <ng-container matColumnDef="imagingType">
        <th mat-header-cell id="imagingType" *matHeaderCellDef>
          {{ "CaseHistory.type" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.imagingType }}</td>
      </ng-container>

      <ng-container matColumnDef="caseStatus">
        <th mat-header-cell id="caseStatus" *matHeaderCellDef  mat-sort-header
        sortActionDescription="Sort by caseStatus">
          {{ "CaseHistory.status" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.caseStatus | titlecase }}</td>
      </ng-container>

      <ng-container matColumnDef="claimantFirstName">
        <th
          mat-header-cell id="claimantFirstName"
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by claimantFirstName"
        >
          {{ "CaseHistory.reviewer" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.claimantFirstName | titlecase}}
        </td>
      </ng-container>

      <ng-container matColumnDef="updateDateTime">
        <th
          mat-header-cell id="updateDateTime"
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by updateDateTime"
        >
          {{ "CaseHistory.completedDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.updateDateTime | localtimezone }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDateTime">
        <th
          mat-header-cell id="dueDateTime"
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by dueDateTime"
        >
          {{ "CaseHistory.dueDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.dueDateTime | localtimezone }}
        </td>
      </ng-container>
      <ng-container matColumnDef="reviewTime">
        <th
          mat-header-cell id="reviewTime"
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by reviewTime"
        >
          {{ "CaseHistory.reviewTime" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            element.status == statusRejected
              ? "-"
              : element.reviewTime
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actionsView">
        <th mat-header-cell id="actionsView" *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let element">
          <button
            class="case-management-button btn-SN-default"
            *ngIf="(element.claimantUserName !== loggedInUser ) ||
                (element.caseStatus === statusRejected )"
                mat-button (click)="navigateMRI(element.caseId)"
          >
            {{ "CaseHistory.View" | translate }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="cursor-pointer"
        mat-row
        *matRowDef="let listItem; columns: displayedColumns"
        [ngClass]="{
          hovered: listItem.hovered,
          highlighted: selectedRowIndex == listItem.caseId
        }"
        (click)="highlightRow(listItem)"
        (mouseover)="listItem.hovered = true"
        (mouseout)="listItem.hovered = false"
      ></tr>
    </table>
    <!-- Show more Button -->
    <button
      *ngIf="
        !(totalPages == caseHistoryData.page + 1) &&
        caseHistoryDetailsRes &&
        totalRec > 0
      "
      class="show-more-button btn-SN-primary font-16 br-4"
      (click)="showMore()"
    >
      {{ "CaseHistory.showMore" | translate }}
    </button>
  </cdk-virtual-scroll-viewport>
    </div>
</div>
